import { render, staticRenderFns } from "./mySwiper.vue?vue&type=template&id=7a1359f1&scoped=true&"
import script from "./mySwiper.vue?vue&type=script&lang=js&"
export * from "./mySwiper.vue?vue&type=script&lang=js&"
import style0 from "./mySwiper.vue?vue&type=style&index=0&id=7a1359f1&scoped=true&lang=css&"
import style1 from "./mySwiper.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1359f1",
  null
  
)

export default component.exports